import Icon from './Icon'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class OverlayTileOptionLink extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    icon: PropTypes.string,
    title: PropTypes.string
  }

  render() {
    const { className, disabled, icon, title, ...rest } = this.props
    const classes = classNames('option-links', { disabled: disabled })

    return (
      <a className={classes} {...rest}>
        <Icon name={icon} />
        {I18n.t(title)}
      </a>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/OverlayTileOptionLink.js